module.exports = __webpack_public_path__ + "img/textura-elvas-1@3x.5568a998.png";